import { useState, useEffect } from 'react'

// Global module-level edit mode state, shared across every component on the site.
let editModeOn = false
const listeners = new Set<() => void>()

const notify = () => listeners.forEach((fn) => fn())

export function useEditMode() {
  const [, setTick] = useState(0)

  useEffect(() => {
    const listener = () => setTick((n) => n + 1)
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }, [])

  const setEditMode = (value: boolean) => {
    editModeOn = value
    notify()
  }

  const toggleEditMode = () => setEditMode(!editModeOn)

  return { editMode: editModeOn, setEditMode, toggleEditMode }
}
